import { useState, useEffect } from "react";
import { Container, Row, Tabs, Tab, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { getVendor, getVendorProfiles } from "../../fetchers/vendor";
import { getProductGroups, getProducts } from "../../fetchers/products";
import { useGetVendorId } from "../../hooks/global/User";
import * as _ from "lodash";

import SingleManualInvitations from "./SingleManualInvitations";
import BatchManualInvitations from "./BatchManualInvitations";
import { useGetCompanyId } from "../../hooks/companies/Companies";
import { useGetAvailableLanguages } from "../../hooks/global/Languages";


const lng = localStorage.getItem("i18nextLng") || "SL";

function ManualInvitations() {
  const { t } = useTranslation();
  const vendorId = useGetVendorId();
  const supportedLanguages = useGetAvailableLanguages();

  const { data:companyId, refetch: getCompanyId } = useGetCompanyId();
  
  const [selectTab, setSelectTab] = useState("single");
  const [vendor, setVendor] = useState([]);
  const [vendorLanguages, setVendorLanguages] = useState(supportedLanguages);
  const [profiles, setProfiles] = useState([]);
  const [groups, setGroups] = useState([]);
  const [products, setProducts] = useState([]);


  const getTabClassName = (tab) => {
    return tab === selectTab ? "active" : "";
  };

  let params = {
    vendorId: vendorId,
    group: "",
    product: "",
    lang: lng.toLocaleUpperCase(),
  };

  useEffect(() => {
    getVendor(vendorId).then((vendors) => {
      setVendor(vendors);
    });
  }, [vendorId]);

  useEffect(() => {
    getVendorProfiles(vendorId).then((vendorProfiles) => {
      setProfiles(vendorProfiles);
    });
  }, [vendorId]);

  useEffect(() => {
    getProductGroups(params).then((vendorModules) => {
      setGroups(vendorModules);
    });
  }, []);

  useEffect(() => {
    getProducts(params).then((vendorProducts) => {
      setProducts(vendorProducts);
    });
  }, []);


  //col-md-12 col-md-offset-2 content
  return (
    <div>
      <div id="artur-profileInviteImport">
        <Container>
          <Row className="justify-content-md-center">
            <Col md={12}>
              <Row className="justify-content-md-center">
                <Col md={12} className="clearfix">
                 {/* <a
                    className="howTo"
                    href={t("admin.common.worksInvUrl")}
                    target="_blank" rel="noreferrer"
                  >
                    {t("products.works")}
                  </a>*/}
                  <div className="navigation" style={{margin:"0px"}}>
                    <h1>{t("admin.inv.h1")}</h1>
                    <h2
                      className={getTabClassName("single")}
                      onClick={() => setSelectTab("single")}
                    >
                      {t("admin.inv.sin")}
                    </h2>
                    <h2
                      className={getTabClassName("batch")}
                      onClick={() => setSelectTab("batch")}
                    >
                      {t("admin.inv.bat")}
                    </h2>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col
                  md={12}
                  className="content"
                >
                  {selectTab === "batch" ? (
                    <BatchManualInvitations
                      vendor={vendor}
                      lng={lng}
                      vendorLanguages={supportedLanguages}
                      groups={groups}
                      profiles={profiles}
                      products={products}
                      vendorId={vendorId}
                      companyId={companyId}
                    />
                  ) : (
                    <SingleManualInvitations
                      vendor={vendor}
                      lng={lng}
                      vendorLanguages={_.intersection(
                        supportedLanguages,
                        vendor.languages
                      )}
                      groups={groups}
                      profiles={profiles}
                      products={products}
                      vendorId={vendorId}
                    />
                  )}
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
}

export default ManualInvitations;
